import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import handFlag from '../../../assets/Icons/handFlag.svg'

import { Typography, Button } from '../../../components'
import useActions from '../../../hooks/useActions'
import { signUpActions } from '../../../redux/ducks/signUp'

import * as S from '../styles'

const FinishStep = () => {
  const history = useHistory()
  const { resetState } = useActions(signUpActions)
  const { isLogged } = useSelector((state) => state.login)

  const finish = async () => {
    resetState()
    history.push(isLogged ? '/user/brands' : '/login')
  }

  return (
    <>
      <Typography type="text" color="#7D7987" spacing="32px 0 0 0">
        Recebemos a sua solicitação
      </Typography>
      <S.FinishContainer>
        <img src={handFlag} alt="handFlag" />
        <Typography type="subTitle" color="#7D7987" spacing="32px 0 0 0">
          Estamos processando o seu pagamento, em breve você
        </Typography>
        <Typography type="subTitle" color="#7D7987">
          será notificado por e-mail com nossos próximos passos!
        </Typography>
      </S.FinishContainer>
      <S.ButtonContainer>
        <Button
          text="FINALIZAR"
          type="button"
          variant="primary"
          width="200px"
          onClick={() => finish()}
        />
      </S.ButtonContainer>
    </>
  )
}

export default FinishStep
